"use client";

import {
    COOKIE_INFORMATION_API_READY_EVENT,
    COOKIE_INFORMATION_CONSENT_CHANGED_EVENT,
    CookieConsentStatus,
    getCookieConsentStatus,
    type CookieConsentCategory,
} from "@lib/analytics/cookieConsent";
import { useEffect, useState } from "react";

const COOKIE_INFORMATION_EVENTS = [
    COOKIE_INFORMATION_API_READY_EVENT,
    COOKIE_INFORMATION_CONSENT_CHANGED_EVENT,
] as const;

export const useCookieConsent = (category: CookieConsentCategory): CookieConsentStatus => {
    const [status, setStatus] = useState<CookieConsentStatus>(CookieConsentStatus.PENDING);

    useEffect(() => {
        const synchronizeConsentStatus = () => {
            setStatus(getCookieConsentStatus(category));
        };

        COOKIE_INFORMATION_EVENTS.forEach((eventName) => {
            window.addEventListener(eventName, synchronizeConsentStatus);
        });

        synchronizeConsentStatus();

        return () => {
            COOKIE_INFORMATION_EVENTS.forEach((eventName) => {
                window.removeEventListener(eventName, synchronizeConsentStatus);
            });
        };
    }, [category]);

    return status;
};
